let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');
let videoClass = '.media-embed';
const videoModalClass = '.modal--media-embed';

class VideoEmbed {
  constructor($videos, context) {
    const playerContainer = $('.video-embed', context);
    const youtubeContainer = $('.video-embed--youtube', $videos).parent();
    const vimeoContainer = $('.video-embed--vimeo', $videos).parent();
    const playBtnYoutube = youtubeContainer.parent().find('.embed-video__btn');
    const playBtnVimeo = vimeoContainer.parent().find('.embed-video__btn');
    const players = {
      youtube: {},
      vimeo: {},
      modalYoutube: {},
      modalVimeo: {},
    };

    /**
     * Adjusts aspect ratio of video
     * @param {Object} $el The target element.
     * @returns {void}.
     */
    function adjustAspectRatio($el) {
      $el.css('position', 'relative');

      // Desktop
      if (breakpoints.current === 'large' || breakpoints.current === 'xlarge') {
        $el.css({
          'padding-bottom': `calc(626 / (${$(window).outerWidth()} - (${$(
            window
          ).outerWidth()} * 0.2)) * 100%)`,
        });
      }
      // Mobile
      else {
        $el.css({
          'padding-bottom': `calc(530 / ${$(window).outerWidth()} * 100%)`,
        });
      }
    }

    adjustAspectRatio(playerContainer);

    // YouTube and Vimeo SDKs added as JS dependencies in libraries.yml.

    /**
     * Play video on mute when player is ready.
     * @param {Object} event The event changes on the player.
     * @returns {void}.
     */
    function onPlayerReady(event) {
      const player = event.target;
      const videoMedia = $(player.i).parent();
      const videoFallback = videoMedia.find('img');

      // Mute the video.
      player.mute();
      player.playVideo();

      if (videoFallback.length > 0) {
        videoFallback.addClass('video-is-playing');
      }
    }

    /**
     * Pauses and plays the video
     * @param {Object} event The event changes on the player.
     * @returns {void}
     */
    function onPlayerStateChange(event) {
      const player = event.target;

      // When the video ends, loop it back to the start.
      if (event.data === 0) {
        player.playVideo();
      }

      // When the state changes to playing, update the buttons and fallback.
      if (event.data === 1) {
        const frame = $(event.target.h);
        const videoMedia = frame.parent();
        const videoFallback = videoMedia.find('img');

        if (videoFallback.length > 0) {
          videoFallback.addClass('video-is-playing');
        }

        const nearestBtn = videoMedia
          .parent()
          .parent()
          .find('.embed-video__btn');
        nearestBtn.addClass('video-is-playing');
      }
    }

    /**
     * Pauses and plays the video
     * @param {Object} $videoId The video id.
     * @param {Object} $video Video popup container.
     * @param {Object} $videoType Tells if the video is from youtube or vimeo.
     * @param {Object} apiType YT or Vimeo
     * @returns {void}
     */
    function videoEmbedModal($videoId, $video, $videoType, apiType) {
      const iframe = $('<iframe></iframe>');

      iframe.attr({
        src: $videoType === 'youtube'
          ? `https://www.youtube.com/embed/${$videoId}?enablejsapi=1&autoplay=1`
          : `https://player.vimeo.com/video/${$videoId}?&autoplay=1`,
        allow: 'autoplay',
        id: `modal-${$videoId}`,
      });

      $($video).find('.media-player').first().append(iframe);

      if ($videoType === 'youtube') {
        players.youtube[$videoId].pauseVideo();
        players.youtube[$videoId].seekTo(0);

        const modalPlayer = new apiType.Player(`modal-${$videoId}`, {
          videoId: `${$videoId}`,
          events: {
            onReady: function onModalPlayerReady(event) {
              event.target.playVideo();
            },
          },
        });

        players.modalYoutube[$videoId] = modalPlayer;
      }
      else {
        players.vimeo[$videoId].pauseVideo();
        players.vimeo[$videoId].setCurrentTime(0);

        const modalPlayer = new apiType.Player(`modal-${$videoId}`);

        players.modalVimeo[$videoId] = modalPlayer;
      }

      // on popup close
      $($video)
        .find('.close')
        .on('click', function () {
          $($video).css('display', 'none');
          iframe.remove();

          if ($videoType === 'youtube') {
            playBtnYoutube.each(function () {
              const playerBtns = $(this)
                .parents('.media-embed')
                .find('.embed-video__btn');
              playerBtns.addClass('video-is-playing');
            });
            players.youtube[$videoId].playVideo();
          }
          else {
            playBtnVimeo.each(function () {
              const playerBtns = $(this)
                .parents('.media-embed')
                .find('.embed-video__btn');
              playerBtns.addClass('video-is-playing');
            });
            players.vimeo[$videoId].play();
          }
        });
    }

    if (context === document) {
      window.onYouTubeIframeAPIReady = function () {
        const YT = window.YT;
        // Create a YT player API handler for each YT video on the page.
        if (YT.Player) {
          $('.video-embed--youtube').each(function () {
            const playerContainer = $(this);
            const playerFrame = $(this).find('.youtube-player');
            const oldFrame = playerContainer.find('.media-oembed-content');
            const playerId = oldFrame
              .attr('src')
              .split('?')[1]
              .split('&')[0]
              .split('/')
              .slice(-1);
            const nearestBtn = playerContainer
              .parents('.media-embed')
              .parent()
              .find('.embed-video__btn');
            const popupBtn = playerContainer
              .parents('.media-embed')
              .parent()
              .find('.video__btn--popup');

            nearestBtn.attr('data-id', playerId);
            playerFrame.attr('id', playerId);
            oldFrame.remove();

            const player = new YT.Player(`${playerId}`, {
              videoId: `${playerId}`,
              events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange,
              },
            });

            nearestBtn.addClass('video-is-playing');
            players.youtube[playerId] = player;

            popupBtn.on('click', function () {
              videoEmbedModal(
                playerContainer.find('.youtube-player').attr('id'),
                $(videoModalClass),
                'youtube',
                YT
              );
              nearestBtn.removeClass('video-is-playing');
              $(videoModalClass).css('display', 'block');
            });
          });

          // Handle click events for the play/pause button.
          playBtnYoutube.on('click', function () {
            // Retrieve the play and pause buttons for this video.
            const playerBtns = $(this).parent().find('.embed-video__btn');

            // Get the player ID and current playback state.
            const playerId = $(this).data('id');
            const state = players.youtube[playerId].getPlayerState();
            const videoMedia = $(this).parent();
            const videoFallback = videoMedia.find('img');

            if (state === 1 || state === YT.PlayerState.PLAYING) {
              playerBtns.removeClass('video-is-playing');
              videoFallback.removeClass('video-is-playing');
              players.youtube[playerId].pauseVideo();
            }
            else {
              // Disable the fallback image.
              videoFallback.addClass('video-is-playing');
              // Loop through other videos and disable their playback.
              $.each(players.youtube, function (key, player) {
                if (key !== playerId.toString()) {
                  player.pauseVideo();
                }
              });
              // Update the playback button and play the video.
              playerBtns.addClass('video-is-playing');
              players.youtube[playerId].playVideo();
            }
          });
        }
      };

      $('.video-embed--vimeo iframe').each(function () {
        const Vimeo = window.Vimeo;
        const playerFrame = $(this);
        const playerId = playerFrame
          .attr('src')
          .split('?')[1]
          .split('&')[0]
          .split('/')
          .slice(-1);
        const nearestBtn = playerFrame
          .parents('.media-embed')
          .parent()
          .find('.embed-video__btn');
        const popupBtn = playerFrame
          .parents('.media-embed')
          .parent()
          .find('.video__btn--popup');
        nearestBtn.attr('data-id', playerId);
        playerFrame.attr('src', 'https://player.vimeo.com/video/' + playerId);
        playerFrame.removeAttr('width');
        playerFrame.removeAttr('height');

        // Store the player by its ID.
        const player = new Vimeo.Player(playerFrame);
        player.setLoop(true);
        player.setVolume(0);

        nearestBtn.addClass('video-is-playing');
        player.play();

        players.vimeo[playerId] = player;

        popupBtn.on('click', function () {
          videoEmbedModal(
            playerFrame.find('.vimeo-player').attr('id'),
            $(videoModalClass),
            'vimeo',
            Vimeo
          );
          nearestBtn.removeClass('video-is-playing');
          $(videoModalClass).css('display', 'block');
        });
      });

      playBtnVimeo.on('click', function () {
        // Retrieve the play and pause buttons for this video.
        const playerBtns = $(this).parent().find('.embed-video__btn');

        // Retrieve the video media fallback image.
        const videoMedia = $(this).parent();
        const videoFallback = videoMedia.find('img');

        // Get the player ID and current playback state.
        const playerId = $(this).data('id');
        const player = players.vimeo[playerId];

        player.getPaused().then(function (paused) {
          if (paused) {
            videoFallback.addClass('video-is-playing');
            playerBtns.addClass('video-is-playing');
            player.play();
            // Loop through other videos and disable their playback.
            $.each(players.vimeo, function (key, player) {
              if (key !== playerId.toString()) {
                player.pause();
              }
            });
          }
          else {
            playerBtns.removeClass('video-is-playing');
            videoFallback.removeClass('video-is-playing');
            player.pause();
          }
        });
      });
    }

    $(window).on('resize', function () {
      adjustAspectRatio(playerContainer);
    });
  }
}

/**
 * Initialize video embed function
 * @param {Object} context Document context.
 */
function init(context) {
  if ($(videoClass).length) {
    $.each($(videoClass), function (index, elem) {
      let videoEmbed = new VideoEmbed(elem, context);
    });
  }
}

if (typeof Drupal === 'undefined') {
  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });
}
else {
  module.exports = {
    attach: function (context, settings) {
      init(context);
    },
  };
}
